import { render } from "./tardiness-reports.vue?vue&type=template&id=022bf50f&scoped=true"
import script from "./tardiness-reports.vue?vue&type=script&lang=js"
export * from "./tardiness-reports.vue?vue&type=script&lang=js"

import "./tardiness-reports.vue?vue&type=style&index=0&id=022bf50f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022bf50f"]])

export default __exports__